import { useState } from 'react';

export type SortDir = 'asc' | 'desc';

export function useSortable<K extends string>(defaultKey: K, defaultDir: SortDir = 'asc') {
  const [sortKey, setSortKey] = useState<K>(defaultKey);
  const [sortDir, setSortDir] = useState<SortDir>(defaultDir);

  function toggle(key: K) {
    if (key === sortKey) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  }

  function sort<T>(arr: T[], getter: (item: T) => string | number | null | undefined): T[] {
    return [...arr].sort((a, b) => {
      const av = getter(a) ?? '';
      const bv = getter(b) ?? '';
      const cmp = av < bv ? -1 : av > bv ? 1 : 0;
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }

  return { sortKey, sortDir, toggle, sort };
}
